module.exports = __webpack_public_path__ + "static/media/fr.dae4d750.svg";